import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ModalModule} from 'ng2-bootstrap/modal';

import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ModalAddTextComponent} from './modal-add-text.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    FormsModule,
    SearchBarModule,
  ],
  declarations: [
    ModalAddTextComponent,
  ],
  exports: [
    ModalAddTextComponent,
  ],
})
export class ModalAddTextModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/apptexts/modal-add-text/modal-add-text.module.ts